module.exports = __webpack_public_path__ + "img/品牌页-海报-标注11.d3bd3456.jpg";